module.exports = __webpack_public_path__ + "static/media/become_a_member_mobile.b2e07391.jpg";